module.exports = __webpack_public_path__ + "static/media/sec_eng2.858e3abb.jpg";